export default __webpack_public_path__ + "static/lozenge-dropdown-do-2-dark-21143a813c0a2a7f711d8c32fc396eaa8e05207d20d05f7b104e8dffc19234db.png";